<button mat-button *ngIf="service && allowedServices.includes(service.slug!)" (click)="openDialog()">
  <mat-icon>add</mat-icon> {{ 'projects.connections.form.new_account_btn_txt' | translate }}
</button>
